import { Stack, Typography } from "@mui/material";

export const NoFeedbackBlock = () => {
  return (
    <Stack gap="8px" alignItems="center" justifyContent="center" flexGrow={1}>
      <Typography
        fontSize="36px"
        lineHeight="44px"
        color="custom.textDarkBlue"
        textAlign="center"
        fontWeight={500}
      >
        No reviews yet
      </Typography>
      <Typography
        variant="subtitle1"
        color="text.secondary"
        textAlign="center"
        maxWidth="354px"
      >
        Once submitted, they will appear here to provide valuable insights.
      </Typography>
    </Stack>
  );
};
